import React from "react";
import { NavLink } from "react-router-dom";
import { IconButton, styled, Tooltip } from "@mui/material";
import { Add } from "@mui/icons-material";

const IconButtonStyled = styled(IconButton)(({ theme }) => ({
  padding: 0,
  cursor: "pointer",
  backgroundColor: theme.color.white100,
  borderRadius: "0.5rem",
  ":hover": {
    backgroundColor: theme.color.hovered,
    boxShadow: `0px 2px 2px ${theme.color.black30}`,
  },
}));

const AddButton = ({ hoverText, onClick }) => {
  return (
    <Tooltip title={hoverText}>
      <IconButtonStyled onClick={onClick}>
        <Add fontSize="large" />
      </IconButtonStyled>
    </Tooltip>
  );
};
const AddButtonContainer = ({ navTo, hoverText, onClick }) => {
  if (navTo) {
    return (
      <NavLink to={navTo}>
        <AddButton hoverText={hoverText} />
      </NavLink>
    );
  }

  return <AddButton hoverText={hoverText} onClick={onClick} />;
};

export default AddButtonContainer;
